var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computedFn } from 'mobx-utils';
import { memoize } from '../../../../utils/mobx/decorators/memoize';
import { flatten, uniq } from '../../../../utils/helper/lodash_replacements';
export class ImportingTreeSearch {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get importingTree() {
        return this.parent;
    }
    get actor() {
        return this.importingTree.actor;
    }
    get allActiveTraitsOfKey() {
        return computedFn((traitKey) => uniq(flatten(this.importingTree.allImportingAspects.map(aspect => aspect.aspectCollectedSets.allAtsOfKey(traitKey)))));
    }
    get allTraitsOfKey() {
        return computedFn((traitKey) => uniq(flatten(this.importingTree.allImportingAspects.map(aspect => aspect.traits.filter(trait => trait.key === traitKey)))));
    }
    get allValuesOfType() {
        return computedFn((valueType) => uniq(flatten(this.importingTree.allImportingAspects.map(aspect => aspect.aspectCollectedSets.allOwnValuesOfType(valueType)))));
    }
    allValuesOfTypeList(entityTypes) {
        return flatten(entityTypes.map(entityType => this.allValuesOfType(entityType)));
    }
}
__decorate([
    memoize
], ImportingTreeSearch.prototype, "allActiveTraitsOfKey", null);
__decorate([
    memoize
], ImportingTreeSearch.prototype, "allTraitsOfKey", null);
__decorate([
    memoize
], ImportingTreeSearch.prototype, "allValuesOfType", null);
